var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2397_189030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74601 1.37323L5.05268 5.06656C4.80602 5.31323 4.66602 5.65323 4.66602 6.00656V12.6666C4.66602 13.3999 5.26602 13.9999 5.99935 13.9999H11.9993C12.5327 13.9999 13.0127 13.6799 13.226 13.1932L15.3993 8.1199C15.9593 6.7999 14.9927 5.33323 13.5593 5.33323H9.79268L10.426 2.2799C10.4927 1.94656 10.3927 1.60656 10.1527 1.36656C9.75935 0.979898 9.13268 0.979898 8.74601 1.37323ZM1.99935 13.9999C2.73268 13.9999 3.33268 13.3999 3.33268 12.6666V7.33323C3.33268 6.5999 2.73268 5.9999 1.99935 5.9999C1.26602 5.9999 0.666016 6.5999 0.666016 7.33323V12.6666C0.666016 13.3999 1.26602 13.9999 1.99935 13.9999Z",
    fill: "#009B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2397_189030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbup);
export default __webpack_public_path__ + "static/media/thumbup.7d6a468e4e342df0935c33ff60a16982.svg";
export { ForwardRef as ReactComponent };